module.exports = __webpack_public_path__ + "img/ball.57b247a4.png";